export default ({ theme }) => `
display: flex;
flex-direction: column;
align-items: flex-start;
width: 100%;

  .input-fields-container {
    display: flex;
    flex-direction: column;
    width: calc(100% - 40px);
    padding: 5px 20px;
    background-color: #f5f5f5;
    border-radius: 5px;

    .input-label-with-info {
      display: flex;
      width: 100%;
      font-size: 14px;
      align-items: center;
      /* margin: 0px 0px -5px 0px !important; */
    }


    h4 {
      margin: 5px 0 0;
      font-size: 14px;
    }


  }

  .email-with-confirmation {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
  }

  .payment-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }

  .action-button-holder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    .action-button-label {
      display: flex;
      font-size: 14px;
      margin-bottom: 5px;
      text-align: -webkit-center;
    }
  }

`;